import React from "react";
import { withStyles, Table, TableHead, TableRow, TableBody, TableCell } from "material-ui";

import PropTypes from "prop-types";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';

// @material-ui/icons
import Stars from "@material-ui/icons/Stars";

import tableStyle from "assets/jss/material-dashboard-react/tableStyle";
import Warning from "components/Typography/Warning.jsx";


class CustomTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.tableData,
            topData: this.props.topData,
            sortKey: 2,
            sort: 'DESC', // DESC
        };

        // http://reactkungfu.com/2015/07/why-and-how-to-bind-methods-in-your-react-component-classes/
        // bind the context for compareBy & sortBy to this component instance
   
        this.sortBy.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let tableData = [];
        if (typeof nextProps.tableData !== 'undefined' && nextProps.tableData.length > 0) {
            tableData = nextProps.tableData;
            tableData = this.sortArray(tableData, this.state.sortKey, this.state.sort);
        }
        this.setState({
            data: tableData,
            topData: nextProps.topData,
            limit: nextProps.limit,
        });
    }


    sortArray(array, key, sort) {
        var sortFunction = this.props.tableSort[key];
        array.sort( sortFunction(key, sort) );
        return array;
    }

    sortBy(key) {
        let arrayCopy = [...this.state.data];
        let sort = this.state.sort;
        if (key === this.state.sortKey) {
            if (sort === 'ASC') {
                sort = 'DESC';
            } else {
                sort = 'ASC';
            }
        }
        arrayCopy = this.sortArray(arrayCopy, key, sort);

        this.setState({
            data: arrayCopy,
            sort: sort,
            sortKey: key,
        });
    }

    sortIcon(key) {
        if (key !== this.state.sortKey) {
            return faSort;
        } else {
            if (this.state.sort === 'ASC') {
                return faSortUp;
            } else {
                return faSortDown;
            }
        }
    }

    render() {
        const {classes, tableHead, tableHeaderColor, limit} = this.props;
        let items = this.state.data;
        items = items.slice(0, limit);
        let topItems = this.state.topData;
        return (
            <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
                <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
            <TableRow>

                        <TableCell className={classes.tableCell + " " + classes.tableHeadCel} key={-1}>
                          <Warning>#</Warning>
                        </TableCell>
              {tableHead.map((prop, key) => {
                    return (
                        <TableCell
                        onClick={() => this.sortBy(key)}
                        className={classes.tableCell + " " + classes.tableHeadCell + " pointer"}
                        key={key}
                        >
                    {prop} <FontAwesomeIcon icon={ this.sortIcon(key)} />
                  </TableCell>
                    );
                })}
            </TableRow>
          </TableHead>
                ) : null}
        <TableBody>
          {topItems.map((prop, key) => {
                return (
                    <TableRow key={key} style={ {
                        backgroundColor: '#fcf8e3'
                    }}>
                        <TableCell className={classes.tableCell} key={-1}>
                          <Stars style={ {
                        color: '#ff9800'
                    }} />
                        </TableCell>
                {prop.map((prop, key) => {
                        return (
                            <TableCell className={classes.tableCell} key={key}>
                      {prop}
                    </TableCell>
                        );
                    })}
              </TableRow>
                );
            })}
          {items.map((prop, key) => {
                return (
                    <TableRow key={key}>
                        <TableCell className={classes.tableCell} key={-1}>
                          {key + 1}
                        </TableCell>
                {prop.map((prop, key) => {
                        return (
                            <TableCell className={classes.tableCell} key={key}>
                      {prop}
                    </TableCell>
                        );
                    })}
              </TableRow>
                );
            })}
        </TableBody>
      </Table>
    </div>
        );
    }
}

CustomTable.defaultProps = {
    tableHeaderColor: "gray"
};

CustomTable.propTypes = {
    classes: PropTypes.object.isRequired,
    tableHeaderColor: PropTypes.oneOf([
        "warning",
        "primary",
        "danger",
        "success",
        "info",
        "rose",
        "gray"
    ]),
    tableHead: PropTypes.arrayOf(PropTypes.string),
//  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string, PropTypes.number))
};

export default withStyles(tableStyle)(CustomTable);



// WEBPACK FOOTER //
// ./src/components/Table/Table.jsx